// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "form.search{background:#f4f7fa;padding:0;display:flex;justify-content:space-between;width:16rem}form.search input,form.search button{margin:0}form.search input{flex-grow:1}form.search button{flex-grow:0;display:flex;align-content:center;padding:10px 15px;border-top-left-radius:0;border-bottom-left-radius:0;padding-left:0}form.search button svg{margin-left:4px}\n", ""]);
// Exports
module.exports = exports;
